import { useEffect, useState } from "react";
import axios from "../../../shared/config/axios-interceptor";
import { useRouter } from "@/shared/utils/hooks/useRouter";
import { CButton, CSpinner } from "@coreui/react-pro";
import { formatVNDNoDecimals } from "@/shared/utils/ultils";
import RenderAutoDat from "./RenderAutoDat";
import ListGiaPCBottom from "./components/ListGiaPCBottom";
import { IoClose } from "react-icons/io5";
import DatCuoc from "./DatCuoc";
import { socket } from "@/shared/config/socket";
import KyQuay from "./components/KyQuay";

const Game = () => {
  const { params } = useRouter();
  const [user, setUser] = useState<any>(null);
  const [game, setGame] = useState<any>(null);
  const [phien, setPhien] = useState<any>(null);
  const [ketQuaKyTruoc, setKetQuaKyTruoc] = useState<any>(null);
  const [load, setLoad] = useState(false);
  const [showBoxDat, setShowBoxDat] = useState(false);
  const getProfile = async () => {
    try {
      if (params?.userId) {
        const res = await axios.get("/user/" + params?.userId);
        setUser(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getGame = async () => {
    try {
      if (params?.id) {
        const res = await axios.get("/game/" + params?.id);
        setGame(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getPhien = async () => {
    try {
      const response = await axios.get("/draws/get-current/" + params?.id);
      setPhien(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getKetQuaKyTruoc = async () => {
    try {
      const response = await axios.get(
        "/draws/get-result-ket-qua-ky-truoc/" + params?.id
      );
      setKetQuaKyTruoc(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getProfile();
    getGame();
    getPhien();
    getKetQuaKyTruoc();
  }, [load]);

  useEffect(() => {
    if (user?.id) {
      socket.on(`update_user_${user?.id}`, (data: any) => {
        setUser({ ...user, ...data });
      });
    }
    return () => {
      socket.off(`update_user_${user?.id}`);
    };
  }, [user]);

  if (!params?.userId || !user || !game)
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            background: "hsl(222.22, 65.85%, 8.04%)",
          }}
        >
          <div className="text-center">
            <p style={{ color: "#fff" }}>Đang vào sảnh...</p>
            <CSpinner color="light" variant="grow" />
          </div>
        </div>
      </>
    );

  return (
    <div className="page-game">
      <div className="container-custom">
        <div className="px-3 py-1 text-center d-flex justify-content-between align-items-center">
          <div>Vòng: {ketQuaKyTruoc?.id}</div>
          <KyQuay ky={phien} load={load} setLoad={setLoad} gameId={game?.id} />
          <div>Sau: {phien?.id}</div>
        </div>

        <div className="py-0">
          <ListGiaPCBottom />
        </div>

        <RenderAutoDat phien={phien} />

        <div
          className={showBoxDat ? "d-none" : "d-block"}
          style={{
            position: "fixed",
            bottom: 0,
            width: "100%",
            left: 0,
            right: 0,
            textAlign: "center",
            zIndex: 2,
          }}
        >
          <div className="p-3 py-2 mb-3">
            <div className="d-flex align-items-center justify-content-between">
              <div
                className="d-flex align-items-center gap-2"
                style={{ color: "rgb(246, 206, 30)" }}
              >
                <i className="fa-solid fa-wallet" style={{ fontSize: 18 }}></i>
                <div>{formatVNDNoDecimals(user?.balance)}</div>
              </div>

              <div>UID: {user?.id}</div>
            </div>
          </div>
          <CButton
            onClick={() => setShowBoxDat(true)}
            className="button-dat-cuoc mb-4"
            style={{
              flexShrink: 0,
              background: "hsl(49 92% 54%)",
              color: "#000",
              fontWeight: "bold",
            }}
          >
            Vào
          </CButton>
        </div>
        <div
          className={`box-bottom p-3 ` + (showBoxDat ? "d-flex" : "d-none")}
          style={{
            background: "hsl(222.86, 29.58%, 13.92%)",
            borderRadius: 5,
            zIndex: 99,
          }}
        >
          <div className="right w-100 px-1">
            <div
              className="text-end mb-3 d-flex align-items-center justify-content-between position-absolute"
              style={{ zIndex: 100, right: 16, top: 16 }}
            >
              <div onClick={() => setShowBoxDat(false)}>
                <IoClose style={{ fontSize: 18 }} />
              </div>
            </div>
            <DatCuoc
              userId={params?.userId}
              phienId={phien?.id}
              setLoad={setLoad}
              load={load}
              game={game}
              user={user}
            />
          </div>
        </div>

        {showBoxDat && (
          <div
            className="overlayout"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.5)",
              zIndex: 1,
            }}
          ></div>
        )}
      </div>
    </div>
  );
};

export default Game;
